(function ($) {
  $.fn.customSelect = function (options) {
    var settings = $.extend(
      {
        multiple: false,
        onChange: null,
      },
      options,
    );

    // Global tracker for open dropdown
    window._customSelectOpenDropdown = window._customSelectOpenDropdown || null;

    return this.each(function () {
      var $element = $(this);
      var $firstOption = $element.find('option:first');
      var placeholder = $firstOption.is('[disabled][hidden]')
          ? $.trim($firstOption.text())
          : 'Select An Option';
      var selectedOptions = [];
      var isOpen = false;
      let typedStr = '';
      let lastTypedTime = 0;
      if (!$element.is('select')) {
        console.error('customSelect: L’élément doit être un <select>');
        return;
      }

      var selectOptions = [];
      $element.find('option').each(function () {
        let $opt = $(this);

        // Skip disabled, hidden, or placeholder
        if (
          $opt.is(':disabled') ||
          $opt.is('[hidden]') ||
          $opt.attr('value') === ''
        ) {
          return;
        }

        // Only push valid options
        selectOptions.push({
          id: $opt.val(),
          label: $opt.text(),
        });
      });

      $element.hide();

      // HTML wrapper
      var html = `
                <div class="custom-select-wrapper" style="position: relative; width: 100%; max-width: 448px;">
                    <button class="custom-select-trigger" style="
                        width: 100%;
                        padding: 12px 16px;
                        text-align: left;
                        background: white;
                        border: 1px solid #d1d5db;
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                    ">
                        <span class="select-text" style="color: #374151;">${placeholder}</span>
                        <svg class="chevron-icon" style="width: 20px; height: 20px; color: #9ca3af; transition: 0.2s;" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <polyline points="6,9 12,15 18,9"></polyline>
                        </svg>
                    </button>

                    <div class="custom-select-dropdown" tabindex="-1" style="
                        position: absolute;
                        top: 100%;
                        left: 0;
                        right: 0;
                        background: white;
                        border: 1px solid #d1d5db;
                        box-shadow: 0 10px 15px -3px rgba(0,0,0,0.1);
                        z-index: 50;
                        overflow-y: auto;
                        max-height: 250px;
                        display: none;
                    "></div>
                </div>

                <div class="select-overlay" style="
                    position: fixed;
                    inset: 0;
                    z-index: 40;
                    display: none;
                "></div>
            `;

      $element.after(html);

      var $wrapper = $element.next('.custom-select-wrapper');
      var $trigger = $wrapper.find('.custom-select-trigger');
      var $dropdown = $wrapper.find('.custom-select-dropdown');
      var $overlay = $wrapper.next('.select-overlay');
      var $selectText = $wrapper.find('.select-text');
      var $chevron = $wrapper.find('.chevron-icon');

      // Overlay & click outside
      $overlay.on('click', toggleDropdown);
      $(document).on('click', function (e) {
        if (isOpen && !$(e.target).closest('.custom-select-wrapper').length) {
          toggleDropdown();
        }
      });

      function buildOptions() {
        var optionsHtml = '';
        selectOptions.forEach(function (option) {
          var isSelected = selectedOptions.includes(option.id);
          var bg = isSelected ? '#ea580c' : 'white';
          var color = isSelected ? 'white' : '#374151';

          optionsHtml += `
                        <div class="select-option" data-id="${
                          option.id
                        }" style="
                            padding: 12px 16px;
                            cursor: pointer;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            background: ${bg};
                            color: ${color};
                        ">
                            <span>${option.label}</span>
                            ${
                              isSelected
                                ? '<svg style="width: 18px; height: 18px;" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"></path></svg>'
                                : '<div style="width: 18px; height: 18px;"></div>'
                            }
                        </div>
                    `;
        });
        $dropdown.html(optionsHtml);
      }

      function updateDisplayText() {
        if (selectedOptions.length === 0) {
          $selectText.text(placeholder);
        } else {
          var opt = selectOptions.find((o) => o.id === selectedOptions[0]);
          $selectText.text(opt ? opt.label : placeholder);
        }
      }

      function syncSelect() {
        $element.val(selectedOptions[0] || '');
        $element.trigger('change');
      }

      function toggleDropdown() {
        // Close other open dropdown
        if (
          !isOpen &&
          window._customSelectOpenDropdown &&
          window._customSelectOpenDropdown[0] !== $dropdown[0]
        ) {
          window._customSelectOpenDropdown
            .closest('.custom-select-wrapper')
            .find('.custom-select-dropdown')
            .hide();
          window._customSelectOpenDropdown
            .closest('.custom-select-wrapper')
            .find('.chevron-icon')
            .css('transform', 'rotate(0deg)');
          window._customSelectOpenDropdown = null;
        }

        isOpen = !isOpen;
        if (isOpen) {
          $dropdown.show();
          $overlay.show();
          $trigger.css({
            'border-color': '#ea580c',
            'box-shadow': '0 0 0 2px rgba(234, 88, 12, 0.2)',
          });
          $chevron.css('transform', 'rotate(180deg)');
          window._customSelectOpenDropdown = $dropdown;

          // ⭐ RESET HIGHLIGHT TO SELECTED VALUE ⭐
          let selectedId = selectedOptions[0];
          let $opts = $dropdown.find('.select-option');

          $opts.removeClass('active').css({
            background: 'white',
            color: '#374151',
          });
          let $sel = $dropdown.find(`.select-option[data-id="${selectedId}"]`);
          $sel.addClass('active').css({
            background: '#ea580c',
            color: 'white',
          });
          if (selectedOptions.length > 0 && selectedOptions[0].length > 0) {
            $dropdown.scrollTop(
              $dropdown.scrollTop() +
                $sel.position().top -
                $dropdown.height() / 2 +
                $sel.outerHeight() / 2,
            );
          }
        } else {
          $dropdown.hide();
          $overlay.hide();
          $chevron.css('transform', 'rotate(0deg)');
          $trigger.css({
            'border-color': '#d1d5db',
            'box-shadow': '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
          });
          window._customSelectOpenDropdown = null;
        }
      }

      function handleOptionClick(optionId) {
        selectedOptions = [optionId];
        updateDisplayText();
        buildOptions();
        syncSelect();
        toggleDropdown();
        if (settings.onChange) settings.onChange(optionId);
      }

      $trigger.hover(
        function () {
          if (!isOpen) {
            $(this).css({
              'border-color': '#ea580c',
              'box-shadow': '0 0 0 2px rgba(234, 88, 12, 0.2)',
            });
          }
        },
        function () {
          if (!isOpen) {
            $(this).css({
              'border-color': '#d1d5db',
              'box-shadow': '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
            });
          }
        },
      );

      // Focus style (TAB navigation)
      $trigger.on('focus', function () {
        if (!isOpen) {
          $(this).css({
            outline: 'none', // FIX black outline

            'border-color': '#ea580c',
            'box-shadow': '0 0 0 2px rgba(234, 88, 12, 0.2)',
          });
        }
      });

      $trigger.on('blur', function () {

        if (!isOpen) {
          $(this).css({
            outline: 'none', // FIX black outline

            'border-color': '#d1d5db',
            'box-shadow': '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
          });
        }
      });

      $trigger.on('blur', function (e) {
        setTimeout(() => {
          const active = document.activeElement;

          // If focus is outside the wrapper => close dropdown
          if (!$(active).closest('.custom-select-wrapper')[0]) {
            if (isOpen) toggleDropdown();
          }
        }, 10);
      });

      $trigger.on('click', function (e) {
        e.preventDefault();
        toggleDropdown();
      });

      $(document).on('click', '.select-option', function (e) {
        if ($(this).closest('.custom-select-wrapper')[0] === $wrapper[0]) {
          e.stopPropagation();
          handleOptionClick($(this).data('id'));
        }
      });

      // TYPE CYCLE + ARROW KEYS + ENTER
      let lastChar = '';
      let lastTime = 0;
      let cycleIndex = 0;

      $(document).on('keydown', function (e) {
        if (!isOpen) return;
        const now = Date.now();

        if (e.key === 'Enter') {
          const $active = $dropdown.find('.active');
          if ($active.length) {
            handleOptionClick($active.data('id'));
            toggleDropdown();
          }

          return;
        }

        // ARROWS ↑ ↓
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault();
          var $opts = $dropdown.find('.select-option');

          // Find the currently "active" option
          var $current = $opts.filter('.active');
          if ($current.length === 0) {
            $current = $opts.filter(function () {
              return $(this).find('svg').length > 0; // fallback if no .active
            });
          }

          var currentIdx = $opts.index($current); // previous index
          if (currentIdx === -1) currentIdx = 0;

          // Calculate new index with wrap-around
          var newIdx;
          if (e.key === 'ArrowDown') {
            newIdx = (currentIdx + 1) % $opts.length; // wrap to first
          } else if (e.key === 'ArrowUp') {
            newIdx = (currentIdx - 1 + $opts.length) % $opts.length; // wrap to last
          }

          // Update active classes and colors
          $opts
            .removeClass('active')
            .css({ background: 'white', color: '#374151' });
          var $new = $opts
            .eq(newIdx)
            .addClass('active')
            .css({ background: '#ea580c', color: 'white' });

          // Scroll dropdown so new option is visible
          $dropdown.scrollTop(
            $dropdown.scrollTop() +
              $new.position().top -
              $dropdown.height() / 2 +
              $new.outerHeight() / 2,
          );

          return;
        }

        // LETTER cycling
        if (e.key.length === 1 && /^[a-zA-Z0-9]$/.test(e.key)) {
          if (e.repeat) return; // ignore repeated key while holding
          const now = Date.now();
          if (now - lastTypedTime > 1000) {
            typedStr = '';
            cycleIndex = 0;
          }

          typedStr += e.key.toLowerCase();
          lastTypedTime = now;

          const matches = selectOptions.filter((opt) =>
            opt.label.trim().toLowerCase().startsWith(typedStr),
          );
          if (!matches.length) return;

          const chosen = matches[cycleIndex % matches.length];
          cycleIndex++;

          $dropdown.find('.select-option').removeClass('active');
          $dropdown
            .find('.select-option')
            .css({ background: 'white', color: '#374151' });
          const $el = $dropdown.find(`.select-option[data-id="${chosen.id}"]`);
          $el.css({ background: '#ea580c', color: 'white' });
          $el.addClass('active');

          $dropdown.scrollTop(
            $dropdown.scrollTop() +
              $el.position().top -
              $dropdown.height() / 2 +
              $el.outerHeight() / 2,
          );

        }
      });

      // INITIAL SELECTED
      var $selectedOption = $element.find('option:selected').first();
      selectedOptions = [$selectedOption.val()];
      updateDisplayText();
      buildOptions();
    });
  };
})(jQuery);
